import { cva, type VariantProps } from 'class-variance-authority';
import { type ReactNode } from 'react';

import { XStack, YStack } from '@/components/ui/layout/layout';

const panelShell = cva('h-full w-full overflow-hidden', {
  variants: {
    variant: {
      floating: 'rounded-[8px] border border-border bg-surface',
      inline: 'bg-background',
    },
  },
  defaultVariants: { variant: 'floating' },
});

interface ArtifactPanelShellProps extends VariantProps<typeof panelShell> {
  title: string;
  leading?: ReactNode;
  actions?: ReactNode;
  iconActions?: ReactNode;
  children: ReactNode;
}

export const ArtifactPanelShell = ({
  title,
  variant,
  leading,
  actions,
  iconActions,
  children,
}: ArtifactPanelShellProps) => (
  <YStack className={panelShell({ variant })}>
    <XStack className="items-center gap-2 p-2 border-b border-border">
      {leading}
      <span
        className="text-sm font-medium text-foreground truncate flex-1"
        title={title}
      >
        {title}
      </span>
      {actions && (
        <XStack className="items-center gap-2 no-drag">{actions}</XStack>
      )}
      {iconActions && (
        <XStack className="items-center gap-1 no-drag">{iconActions}</XStack>
      )}
    </XStack>
    {children}
  </YStack>
);
